import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var searchDetailRoute = [{
  path: "search-detail/:name",
  name: "search-detail",
  component: function component() {
    return import("./search-detail.vue");
  }
}];